module.exports = __webpack_public_path__ + "img/grid_template.fa47d853.jpg";